<div
  #originRef
  (click)="showPopover(originRef)"
  [class.bg-hover]="dropdownOpen"
  class="flex items-center rounded cursor-pointer relative trans-ease-out select-none py-1 pr-1 pl-1 hover:bg-hover"
  matRipple>
  <div class="flex items-center rounded body-1 font-medium leading-snug">
    <img
      *ngIf="checkURL(profileImage)"
      class="user-profile"
      width="2rem"
      height="2rem"
      [src]="loginUserData.Avatar"
      alt="" />
    <ngx-avatar
      *ngIf="!checkURL(profileImage)"
      [bgColor]="profileImage"
      fgColor="black"
      size="32"
      [name]="loginUserData.userName"
      value="75%"></ngx-avatar>
    <span class="ml-2" fxHide.xs fxHide.sm>{{ loginUserData.userName }}</span>
  </div>
  <div
    fxHide.xs
    fxHide.sm
    class="rounded-full h-9 w-9 flex items-center justify-center text-primary">
    <mat-icon [icIcon]="icMore"></mat-icon>
  </div>
</div>
